import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <section className="services" id='services'>
      <h2>Our Services</h2>
      <ul>
        <li>Employee Onboarding - Simplify the process of welcoming new team members.</li>
        <li>Performance Management - Track and assess employee performance effectively.</li>
        <li>Payroll Processing - Hassle-free payroll management for your organization.</li>
        <li>HR Analytics - Get insights into your workforce and make data-driven decisions.</li>
      </ul>
    </section>
  );
};

export default Services;
